import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { LoginService2, UserService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class TokenizationActivateGuard {
    constructor(
        private userService: UserService,
        private loginService: LoginService2,
    ) {}

    canActivate(route: ActivatedRouteSnapshot) {
        const isPreview = route.queryParams['previewMode'] ?? '';

        if (!isPreview && !this.userService.isAuthenticated) {
            this.loginService.goTo({
                appendReferrer: true,
                referrerNeedsLoggedInUser: true,
            });
        }

        return true;
    }
}
